import { Box } from "@mui/material";
import UNIVERSAL from "config";

const ViewAttachment = ({ setViewAtt, file }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        zIndex: "100",
        top: "0",
        left: "0",
        height: "100%",
        width: "100%",
        overflowY: "auto",
        backgroundColor: "#000000e0",
        borderRadius: "5px",
      }}
      onClick={() => setViewAtt(false)}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          "& img": {
            maxWidth: "80%",
          },
        }}
      >
        {file?.mime_type.includes("image") && (
          <img
            src={UNIVERSAL.BASEURL + file?.file}
            alt=""
            onClick={(e) => e.stopPropagation()}
          />
        )}
      </Box>
    </Box>
  );
};

export default ViewAttachment;
